import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, Row, Col } from "reactstrap"

import { Link } from "react-router-dom"

// services
import ApplicationService from "../../services/applications/Application.service"
import Staff from "services/staff/Staff"
import { AvForm, AvField } from "availity-reactstrap-validation"

import Application from "services/applications/Application.service"

const loggedInUser = JSON.parse(localStorage.getItem("authUser"))
const appService = new Application(loggedInUser)

let plasticsUser = null
let staffService = new Staff()
const BASE_URL = process.env.REACT_APP_BASE_URL

const Report = () => {
  const [menu, setMenu] = useState(false)
  const [user, setuser] = useState()
  const [mounted, setmounted] = useState(false)
  const [reportUrl, setreportUrl] = useState("")

  const toggle = () => {
    setMenu(!menu)
  }

  useEffect(() => {
    if (reportUrl != "") {
      document.getElementById("repLink").click()
     }
  }, [reportUrl])

  useEffect(() => {
    const userObj = JSON.parse(localStorage.getItem("authUser"))

    setuser(userObj)
  }, [])

  const handleSubmit = values => {
    setreportUrl(
      BASE_URL +
        "reports/clients/all?start_date=" +
        values.start_date +
        "&end_date=" +
        values.end_date +
        "&status=" + values.status
    )
    
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Reports | HoD</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={8}>
                <h6 className="page-title">Reports</h6>
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active">Report Search</li>
                </ol>
              </Col>
            </Row>
          </div>

          <AvForm
            onValidSubmit={(e, v) => {
              handleSubmit(v)
            }}
          >
            <Row>
              <Col md={4}>
                <div className="mb-3">
                  <AvField
                    name="start_date"
                    label="Start Date"
                    type="date"
                    required
                  />
                </div>
              </Col>
              <Col md={4}>
                <AvField
                  name="end_date"
                  label="End Date"
                  type="date"
                  required
                />
              </Col>

              <Col md={4}>
                <AvField
                  type="select"
                  name="status"
                  label="Select Status"
                  required
                >
                  <option value="">--select--</option>
                  <option value="6">Approved</option>
                  <option value="3">Under Review</option>
                  <option value="9">Rejected</option>
                </AvField>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col md={6}></Col>
              <Col md={6}>
                <button
                  type="submit"
                  style={{ float: "right" }}
                  className="btn btn-primary btn-block"
                >
                  Download Report
                </button>
              </Col>
            </Row>
            <a
              id="repLink"
              style={{ display: "none" }}
              href={reportUrl}
              target="_blank"
            >
              View Certificate
            </a>
          </AvForm>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Report
